.highlightedColumn {
  background-color: #f7f7f7;
}

.highlightedColumn:first-of-type {
  border-radius: 12px 0 0 12px;
}

.highlightedColumn:last-of-type {
  border-radius: 0 12px 12px 0;
}

.accordionPanel {
  background-color: white;
  margin-top: var(--mantine-spacing-sm);
  border-radius: 16px;
  border: solid 1px var(--mantine-color-gray-3);
  padding: var(--mantine-spacing-sm);
}

.accordionBadge {
  background-color: white;
  border-color: var(--mantine-color-gray-3);
  color: var(--mantine-color-gray-9);
}
